var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholderSignature({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 247 100",
    width: 247,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.73 32.63c-1.184.361-2.191.969-3.143 1.759-2.07-1.561-4.796-2.025-7.344-1.246-1.272.388-2.464 1.053-3.36 2.024a8.29 8.29 0 00-6.96-.966c-.636.195-1.155.455-1.671.71l-5.523-18.064c-1.34-4.38-6.001-6.945-10.461-5.581-4.457 1.362-6.92 6.004-5.552 10.476l10.236 33.48-5.605-4.669c-1.593-1.31-3.776-1.94-5.859-1.599-2.085.338-3.946 1.405-5.43 3.056-1.365 1.714-2.139 3.747-1.98 5.893a7.376 7.376 0 002.667 5.47c.265.219 23.312 19.308 27.296 22.579 4.992 3.96 12.902 5.43 19.27 3.484l6.188-1.892c11.19-3.421 17.615-15.26 14.304-26.421l-6.973-22.808c-1.429-4.648-5.733-7.022-10.1-5.687zm12.379 29.434l.111.363c2.557 8.695-2.415 17.8-11.15 20.47l-6.187 1.891c-5.459 1.67-11.675-.12-14.838-2.645-3.956-3.178-27.03-22.36-27.267-22.486a2.942 2.942 0 01-.916-2.015c-.069-.876.316-1.893.877-2.661.497-.65 1.17-1.055 1.898-1.278l.548-.167a2.64 2.64 0 012.154.537l11.743 9.775c.798.653 2.001.686 2.827.134.918-.581 1.275-1.688.97-2.69L180.326 20.24a3.618 3.618 0 012.398-4.525 3.618 3.618 0 014.518 2.41l9.985 32.661a2.36 2.36 0 002.972 1.586 2.36 2.36 0 001.577-2.976l-2.957-9.672c.436-.531.923-.883 1.559-1.077 1.365-.417 2.799.04 3.733 1.154l2.65 8.666c.39 1.276 1.7 1.975 2.972 1.586s1.967-1.7 1.577-2.976l-2.482-8.118c.497-.65 1.049-1.12 1.87-1.37 1.457-.446 3.129.142 4.002 1.371l2.315 7.573a2.36 2.36 0 002.972 1.585 2.36 2.36 0 001.577-2.976l-2.092-6.842c.408-.624 1.077-1.027 1.717-1.223 2-.611 3.532.814 4.063 2.55z",
    fill: "#2bb7d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 17c-19.074 33.333-39.45 50-61.125 50-29.587 0-12.016-32.81-52.473-38.593C50.8 26.463 33.332 32.3 12 45.919",
    stroke: "#2bb7d9",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderSignature);
export default __webpack_public_path__ + "static/media/placeholder-signature.b6c4258757461eab3a7d064441880ba1.svg";
export { ForwardRef as ReactComponent };